// extracted by mini-css-extract-plugin
module.exports = {"popUpWrapper":"GrayOutBackground_popUpWrapper__2Xkey","grayOutScreen":"GrayOutBackground_grayOutScreen__2XQsi"};